module.exports = __webpack_public_path__ + "static/img/v21TwoDetailImg.caa2d57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v21TwoDetailImg.png
// module id = tdIZ
// module chunks = 1